(function($) {
	var freeShippingPrice = 69;
	var title = window.freeShippingNote.title;
	var subtitle = window.freeShippingNote.subtitle;
	var title_after = window.freeShippingNote.title_after;
	var subtitle_after = window.freeShippingNote.subtitle_after;

	function formatMoney(cents, format) {
		if (typeof cents == 'string') { cents = cents.replace('.',''); }
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = format;
	
		function defaultOption(opt, def) {
			return (typeof opt == 'undefined' ? def : opt);
		}
	
		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal   = defaultOption(decimal, '.');
		
			if (isNaN(number) || number == null) { return 0; }
		
			number = (number/100.0).toFixed(precision);
		
			var parts   = number.split('.'),
				dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
				cents   = parts[1] ? (decimal + parts[1]) : '';
		
			return dollars + cents;
		}
	
		switch(formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
		}
	
		return formatString.replace(placeholderRegex, value);
	}

	function updatePrice() {
		var price = parseFloat(freeShippingPrice).toFixed(2);
		
		getCart()
			.then(function(cart) {
				var currentPrice = cart.total_price.toString();
				currentPrice = currentPrice.substring(0, currentPrice.length - 2) + "." + currentPrice.substring(currentPrice.length - 2);
				currentPrice = parseFloat(currentPrice).toFixed(2);
				
				var shippingLeft = parseFloat(price - currentPrice).toFixed(2);
				
				if (shippingLeft <= 0) {
					fillFreeShippingNote(title_after, subtitle_after);
					fillHeaderFreeShippingNote(subtitle_after);
				} else {
					shippingLeft = formatMoney(shippingLeft, theme.moneyFormat);
					fillFreeShippingNote(title.replace('%shipping', freeShippingPrice), subtitle.replace('%shippingLeft', shippingLeft));
					
					if (cart.item_count === 0) {
						fillHeaderFreeShippingNote(title.replace('%shipping', freeShippingPrice));
					} else {
						fillHeaderFreeShippingNote(subtitle.replace('%shippingLeft', shippingLeft));
					}
				}
			});
	}

	function fillFreeShippingNote(title, subtitle) {
		var $freeShippingNote_textWrapper = $('.freeShippingNote__textWrapper');

		$freeShippingNote_textWrapper.each(function(index, element) {
			var $element = $(element);

			$element.html('');

			$('<div />').css({ color: 'rgb(236, 96, 149)' }).html(title).appendTo($element);
			$('<div />').css({ color: 'rgb(0, 0, 0)' }).html(subtitle).appendTo($element);
		});
	}

	function fillHeaderFreeShippingNote(text) {
		var $container = $('.headerFreeShippingNote');

		$container.each(function(index, element) {
			var $element = $(element);
			$element.html(text);
		});
	}

	function getCart() {
		return $.ajax({
			url: '/cart.js',
			success: function(response) {
				console.log(response);
			},
			dataType: 'json'
		});
	}

	function listenToCartUpdates() {
		XMLHttpRequest.prototype.realSend_freeShippingNote = XMLHttpRequest.prototype.send;
		XMLHttpRequest.prototype.send = function(value) {
			this.addEventListener("load", function() {
				if ((this._url === '/cart/add.js' || this._url === '/cart/change.js' || this._url === '/cart/update.js') && this._method === 'POST') {
					updatePrice();
				}
			}, false);
			this.realSend_freeShippingNote(value);
		}
	}

	try {
		listenToCartUpdates();
	} catch (err) {
		
	}

	updatePrice();
	
})(jQuery);